import { Card, Grid } from "@mui/material";

import { IIndividual } from "../../pages/Schedule/FamilyGroup/model";
import TriageIndividual from "./TriageIndividual";

const EmergencyCareCardIndividual = ({
  padding,
  individual,
  onClick,
}: {
  padding?: number;
  individual: IIndividual;
  onClick?: () => void;
}) => {
  return (
    <Card
      sx={(theme) => ({
        padding: padding ? padding : 2,
        width: "100%",
        maxWidth: 450,
        maxHeight: 200,
        border: `2px solid transparent`,
        cursor: "pointer",
        position: "relative",
        backgroundColor:
          theme.palette.mode === "light" ? theme.palette.grey[100] : "#121212",
      })}
      onClick={() => {
        if (onClick) onClick();
      }}
      elevation={0}
    >
      <Grid container sx={{ flexDirection: "row", opacity: 1 }}>
        <TriageIndividual individual={individual} />
      </Grid>
    </Card>
  );
};

export default EmergencyCareCardIndividual;
